const paddings = {
  mobileLR: "padding: 0 14px;",
  mobileInComponentTopPadding: "padding: 14px 0;",
  tabletUpLR: "padding: 0 25px",
  tabletLandscapeUpLR: "padding: 0 40px",
};

export default paddings;
